import getUserAgentDetails from '@hh.ru/browser-api-utils/lib/modules/getUserAgentDetails';

(function () {
    window.bloko = window.bloko || {};
    window.bloko.getUserAgentDetails = getUserAgentDetails;
})();
